module.exports = __webpack_public_path__ + "img/nomad7.ca2ca472.jpg";